import { Component } from "react";
import { Button, ButtonGroup, Col, Form, InputGroup, Modal, ToggleButton, ToggleButtonGroup } from "react-bootstrap";
import Select from 'react-select'
import axiosInstance from "../../axiosInstance";
class Onu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selected_package: null,
            delete : {
                showModal : false
            }
        }
    }

    getSelectedPackage(){
        return this.props.internet_packages.filter(e => e.value == this.props.element.internet_package_id)[0];
    }

    componentDidMount() {
        this.setState({
            selected_package:this.getSelectedPackage(),
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.internet_packages.length !== prevProps.internet_packages.length){
            this.setState({
                selected_package:this.getSelectedPackage()
            })
        }
    }

    deleteOnu(){
        axiosInstance.delete('tickets/onu/' + this.props.element.id)
        .then(response => {
            this.setState({
                delete :{
                    ...this.state.delete,
                    showModal : false
                }
            })
            this.props.update();
        })
        .catch(err => {
            console.log(err)
        })
    }

    render() {
        return (
            <Form.Row className="onu">
                <Form.Group as={Col} md="12">
                    <Form.Row>
                        <Form.Group as = {Col} md={2}>
                            <Form.Label>INTERNET</Form.Label>
                        </Form.Group>
                        {this.props.isEditable && <Form.Group className="d-flex flex-row-reverse" as = {Col} md={{span : 1,offset:9}} >
                            <Button variant = "danger" onClick = {() => {
                                this.setState({
                                    delete :{
                                        ...this.state.delete,
                                        showModal: true
                                    }
                                })
                            }}><i class="fas fa-trash-alt"></i></Button>
                        </Form.Group>}
                    </Form.Row>
                    
                </Form.Group>
                <Form.Group as={Col} md="2">
                    <Form.Label>ODF სახელი</Form.Label>
                    <Form.Control
                        type="text"
                        name="odf_name"
                        disabled={true}
                        value = {this.props.element.odf_name}
                    />
                </Form.Group>
                <Form.Group as={Col} md="1">
                    <Form.Label>Port</Form.Label>
                    <Form.Control
                        type="text"
                        name="port"
                        disabled={true}
                        value={this.props.element.port}
                    />
                </Form.Group>
                <Form.Group as={Col} md="1">
                    <Form.Label>Vport</Form.Label>
                    <Form.Control
                        type="text"
                        name="vport"
                        disabled={true}
                        value={this.props.element.vport}
                    />
                </Form.Group>
                <Form.Group as={Col} md="4" >
                    <Form.Label>ჩასართავი პაკეტი</Form.Label>
                    <Select
                        options={this.state.internet_packages}
                        onChange={(e) => {
                            this.setState({
                                internet_package_id: e.value
                            })
                        }}
                        isDisabled={true}
                        value={this.state.selected_package}
                        placeholder="აირჩიეთ" />
                </Form.Group>
                <Form.Group as={Col} md="2">
                    <Form.Label>Mac</Form.Label>
                    <Form.Control
                        type="text"
                        name="vport"
                        disabled={true}
                        value={this.props.element.mac}
                    />
                </Form.Group>
                <Form.Group as={Col} md="2">
                    <Form.Label>Serial</Form.Label>
                    <Form.Control
                        type="text"
                        name="vport"
                        disabled={true}
                        value={this.props.element.serial}
                    />
                </Form.Group>
                <Modal
                    show={this.state.delete.showModal} 
                    centered
                    onHide = {() => {
                        this.setState({
                            delete : {
                                ...this.state.delete,
                                showModal : false
                            }
                        })
                    }}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>INTERNET წაშლა</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                       დანამდვილებით გსურთ წაშლა?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="success" onClick={(event) => {
                            this.deleteOnu()
                        }} >
                            წაშლა
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Form.Row>
        );
    }
}
export default Onu;